import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/WaitingMission.png'


const _withScopeId = n => (_pushScopeId("data-v-6901b2c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login_box"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login_box_img",
  src: _imports_0,
  alt: "waiting mission"
}, null, -1))
const _hoisted_4 = { class: "input_box email" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "loginEmail" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-mail-o" })
], -1))
const _hoisted_6 = ["disabled", "onKeydown"]
const _hoisted_7 = { class: "input_box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "loginPassword" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-lock-o" })
], -1))
const _hoisted_9 = ["disabled", "onKeydown"]
const _hoisted_10 = { class: "remember_box" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rememberMe" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Stay Signed in ")
], -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "sign_up_btn" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xi-angle-right-min" }, null, -1))

import { reactive, ref } from 'vue';
import { storeToRefs } from 'pinia';

import { AccessMemberInfoType } from '@/interface/member';
import Signup from '@/components/common/Signup.vue';
import useCommonStore from '@/store/storeCommon';
import useMapStore from '@/store/storeMap';
import useMemberStore from '@/store/storeMember';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginBox',
  setup(__props) {

const {
  isLoading,
  isMobile,
  isMainLogo,
} = storeToRefs(useCommonStore());
const {
  inputValueAni,
  disabledQualification,
  showPanel,
  showModal,
  showSignupToggle,
  modalContents,
} = useCommonStore();
const { accessLogin, accessedMemberInfo } = useMemberStore();
const { getSatelliteDataApi } = useMapStore();

const isRememberChecked = ref<boolean>(false); // 'Remember me' 체크 유무

// 로그인 할 유저 정보
const loginForm: AccessMemberInfoType = reactive({
  email: '',
  password: '',
});

/**
 * 로그인 기능을 실행합니다.
 */
const submitLogin = async (): Promise<void> => {
  try {
    isLoading.value = true;

    await accessLogin(loginForm, isRememberChecked.value);
    await getSatelliteDataApi();

    const accessToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
    if (accessToken) {
      Object.assign(loginForm, {
        email: '',
        password: '',
      });
    } else {
      showModal.isFail = true;
      isMainLogo.value = true;

      Object.assign(modalContents, {
        title: 'Login Failed',
        description: '아이디 또는 패스워드\n정보가 일치하지 않습니다.',
      });
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;

    if (isMobile && accessedMemberInfo.name && showPanel.isMobileAccountInfo) {
      showPanel.isMobileAccountInfo = false;
    }
    if (!isMobile.value && accessedMemberInfo.name && !showPanel.isAccountInfo) {
      showPanel.isAccountInfo = true;
    }
  }
};

/**
 * 'Forget Account' 모달창을 엽니다.
 */
const openForgotAccount = (): void => {
  isMainLogo.value = true;
  showModal.isForgotAccount = true;
};

return (_ctx: any,_cache: any) => {
  return (!_unref(accessedMemberInfo).name)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_TransitionGroup, {
          name: "fade",
          tag: "div"
        }, {
          default: _withCtx(() => [
            (!_unref(showPanel).isSignUp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _withDirectives(_createElementVNode("input", {
                      id: "loginEmail",
                      type: "text",
                      placeholder: "EMAIL",
                      disabled: _unref(disabledQualification)(),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.email) = $event)),
                      onKeydown: _withKeys(_withModifiers(submitLogin, ["prevent"]), ["enter"]),
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args)))
                    }, null, 40, _hoisted_6), [
                      [_vModelText, loginForm.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                      id: "loginPassword",
                      type: "password",
                      placeholder: "PASSWORD",
                      disabled: _unref(disabledQualification)(),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loginForm.password) = $event)),
                      onKeydown: _withKeys(_withModifiers(submitLogin, ["prevent"]), ["enter"]),
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args)))
                    }, null, 40, _hoisted_9), [
                      [_vModelText, loginForm.password]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "rememberMe",
                        type: "checkbox",
                        disabled: _unref(disabledQualification)(),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isRememberChecked).value = $event))
                      }, null, 8, _hoisted_11), [
                        [_vModelCheckbox, isRememberChecked.value]
                      ]),
                      _hoisted_12
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      disabled: _unref(disabledQualification)(),
                      onClick: openForgotAccount
                    }, " Forgot Account ", 8, _hoisted_13)
                  ]),
                  _createElementVNode("button", {
                    class: "sign_in_btn",
                    type: "button",
                    disabled: _unref(disabledQualification)(),
                    onClick: submitLogin
                  }, " Sign in ", 8, _hoisted_14),
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(" Don't have an account? "),
                    _createElementVNode("button", {
                      type: "button",
                      disabled: _unref(disabledQualification)(),
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(showSignupToggle) && _unref(showSignupToggle)(...args)))
                    }, [
                      _createTextVNode(" Sign up "),
                      _hoisted_17
                    ], 8, _hoisted_16)
                  ])
                ]))
              : (_openBlock(), _createBlock(Signup, { key: 1 }))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})